import React, { useState, useEffect } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import KeyboardIcon from '@mui/icons-material/Keyboard';
import { btoa, toUnicode } from '../../../cryptographic/crypto';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';

function CalenderPicker({ message, sendMessage, appointment, setAppointment, btnTypeG, setbtnTypeG, socket, indexLength, arrayLength,scrollToBottom,openMic}) {
    const [startDate, setStartDate] = useState(new Date(message?.value?.date));
    const [apoointmentDate, setAppointmentdate] = useState(message)

    const [prevAppointment, setPrevAppointmentdate] = useState()
    const [btnType, setbtnType] = useState("footer")
    const [showBtn, setShowBtn] = useState(true)

    const [calLocked, setCalLocked] = useState(false)


    const [formData, setformData] = useState(
        {
            appointment: null,
            date: startDate
        }
    )

    const sendCalMessage = (date) => {
        const newDate = new Date(date).toLocaleDateString("en-GB")
        let sendData = {
            text: toUnicode(newDate),
            payload: toUnicode("data_fill__date__"+ new Date(date).toLocaleDateString("zh-Hans-CN")),
            notification: 'N'
        }
        socket.emit(btoa(["user-send", sendData]));
    }

    const sendMessage2 = (e) => {
        console.log(e, "appoint detaisl")
        let sendData = {
            text: toUnicode(e.title),
            payload: toUnicode(e.payload),
            notification: 'N'
        }
        socket.emit(btoa(["user-send", sendData]));
        setPrevAppointmentdate(apoointmentDate)
        setAppointmentdate([])
        setAppointment([])
    }


    useEffect(() => {
        if (appointment !== "" || appointment !== undefined) {
            setAppointmentdate(appointment)
        }
    }, [appointment]);

    useEffect(() => {
        // console.log(arrayLength +"Arraylength  - " + indexLength+ "IndexLength")
        // console.log(parseInt(arrayLength?.length-1) > parseInt(indexLength+3), "timeSlotLength1")
        // console.log(!arrayLength[parseInt(arrayLength?.length-1)]?.template?.template?.elements?.buttons?.filter(component => component.type === "time_slot").length, "timeSlotLength2")
        if (parseInt(arrayLength?.length - 1) > parseInt(indexLength + 3) && 
            (!arrayLength[parseInt(arrayLength?.length-1)]?.template?.template?.elements?.buttons?.filter(component => component.type === "time_slot").length)
         && arrayLength[parseInt(arrayLength?.length - 1)]?.template !== ""
         && !arrayLength[parseInt(arrayLength?.length - 1)]?.template?.hasOwnProperty('ssml')) 
         {
            setCalLocked(true)
            setShowBtn(false)
        }
    }, [arrayLength])
    const scrollPage =()=>{
        // alert("hehe")
        setTimeout(() => {
            scrollToBottom()
        }, 400);
    }
    return (
        <>
            <div className="calender-card">
                {
                    calLocked ?
                        <div className='calender-locked'></div>
                        :
                        <></>
                }
                <div className="calender-card-head">Schedule Appointment</div>
                <DatePicker selected={startDate} minDate={new Date()} onChange={(date) => { setStartDate(date); sendCalMessage(date); setAppointmentdate(appointment); }} inline />
                {
                    appointment !== "" && appointment !== undefined ?
                        <div className="appointment-card">
                            <div className="appointment-head">{apoointmentDate?.title}</div>
                            <div className="appointmnet-btn-wrapper">
                                {
                                    calLocked ?
                                        prevAppointment?.buttons?.map((appoint, i) => {
                                            return (
                                                appoint.payload === "" ?
                                                    <p className='appoint-not-available'>{appoint.title}</p>
                                                    :
                                                    <button type="button" className={`btn-outline mb-8 ${formData?.appointment?.title === appoint.title ? "active-btn" : ""}`} onClick={() => setformData({ ...formData, appointment: appoint })} key={i} >{appoint.title}</button>
                                            )
                                        })
                                        :
                                        apoointmentDate?.buttons?.map((appoint, i) => {
                                            return (
                                                appoint.payload === "" ?
                                                    <p className='appoint-not-available'>{appoint.title}</p>
                                                    :
                                                    <button type="button" className={`btn-outline mb-8 ${formData?.appointment?.title === appoint.title ? "active-btn" : ""}`} onClick={() => setformData({ ...formData, appointment: appoint })} key={i} >{appoint.title}</button>
                                            )
                                        })
                                }
                            </div>
                        </div>
                        :
                        <></>
                }
            </div>
            {
                showBtn ?
                    btnTypeG === "chat" ?
                        <button type="button" className="btn-default btn-seprate" onClick={() => { setShowBtn(false); sendMessage(formData?.appointment); setCalLocked(true) }}>{"Schedule Appointment"}</button>
                        :
                        btnType === "footer" ?
                            formData.appointment ?
                                <div className="appointment-footer-wrapper">
                                    {
                                        openMic ?
                                            <KeyboardVoiceIcon onClick={() => { setbtnType("chat"); setbtnTypeG("chat");scrollPage() }} />
                                        :
                                        <KeyboardIcon  onClick={() => { setbtnType("chat"); setbtnTypeG("chat");scrollPage() }} />       
                                    }
                                    <button type="button" className="btn-default btn-seprate" onClick={() => { setShowBtn(false); sendMessage2(formData?.appointment); setCalLocked(true) }}>{"Schedule Appointment"}</button>
                                </div>
                                :
                                <div className="appointment-footer-wrapper">
                                    {
                                        openMic ?
                                            <KeyboardVoiceIcon onClick={() => { setbtnType("chat"); setbtnTypeG("chat");scrollPage() }} />
                                        :
                                        <KeyboardIcon  onClick={() => { setbtnType("chat"); setbtnTypeG("chat");scrollPage() }} />       
                                    }
                                    <button type="button" className="btn-default btn-seprate btn-disabled">{"Schedule Appointment"}</button>
                                </div>
                            :
                            formData.appointment ?
                                <button type="button" className="btn-default btn-seprate" onClick={() => { setShowBtn(false); sendMessage2(formData?.appointment); setCalLocked(true) }}>{"Schedule Appointment"}</button>
                                :
                                <button type="button" className="btn-default btn-seprate btn-disabled">{"Schedule Appointment"}</button>
                    :
                    <></>
            }
        </>
    )
}
export default CalenderPicker
